import { render, staticRenderFns } from "./overview-saved-assessments-standard.vue?vue&type=template&id=7a4f853a&scoped=true&"
import script from "./overview-saved-assessments-standard.vue?vue&type=script&lang=js&"
export * from "./overview-saved-assessments-standard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4f853a",
  null
  
)

export default component.exports